import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PledgePerWinSite } from '../../_models/fundraising/ppw/PledgePerWinSite';
import { getUrl } from '../../_shared/utils';
import { JWTTokenService } from '../jwtToken.service';
import { FundraisingSiteService } from './fundraisingSite.service';

@Injectable()
export class PledgePerWinSiteService extends FundraisingSiteService {

    constructor(
        protected http: HttpClient,
        protected jwtTokenService: JWTTokenService) 
        { 
            super(http, jwtTokenService);
        }

    
    public getSiteData(): Observable<PledgePerWinSite> {
        return this.http.get<PledgePerWinSite>(getUrl('fundraising/ppw/site/customize'), this.requestOptionsAuthenticated('portal'));
    }

    public create(data: PledgePerWinSite): Observable<PledgePerWinSite> {
        return this.http.post<PledgePerWinSite>(getUrl('fundraising/ppw/site/customize/create'), data, this.requestOptionsAuthenticated('portal'));
    }

    public update(data: PledgePerWinSite): Observable<PledgePerWinSite> {
        return this.http.post<PledgePerWinSite>(getUrl('fundraising/ppw/site/customize/update'), data, this.requestOptionsAuthenticated('portal'));
    }

    public getHostnameAvailability(name: string): Observable<any> {
        return this.http.get(getUrl(`fundraising/ppw/site/customize/availability?name=${name}`), this.requestOptionsAuthenticated('portal'));
    }

    public deleteLegalPdf(objectPath: string): Observable<boolean> {
        const s3Object = { objectPath };
        return this.http.post<boolean>(getUrl('fundraising/ppw/site/delete-pdf'), s3Object, this.requestOptionsAuthenticated('portal'));
    }  
}